import React from 'react';

import dynamic from 'next/dynamic';

import { useDevice } from '@contexts/device';

import { TourSelectionCardProps } from './props';

const DesktopTourSelectionCard = dynamic(
  () => import('./DesktopTourSelectionCard'),
  {
    ssr: true,
  }
);

const MobileTourSelectionCard = dynamic(
  () => import('./MobileTourSelectionCard'),
  {
    ssr: true,
  }
);
const TourSelectionCard = ({
  full,
  price1,
  price2,
  price3,
  price1Discounted,
  price2Discounted,
  price3Discounted,
  childPriceList = [],
  dates,
  roomQuota,
  hideQuotaInfo,
  packageId,
  packageDetailId,
  companyCommissionAmount,
  days,
  status,
  checkInDate,
  checkOutDate,
  entityName = '',
  tourType,
  currencyName,
  tourId,
  data,
  personQuota,
  pagesName,
  departureDate,
  departureText,
  arrivalDate,
  arrivalText,
  departurePointList,
  cashDiscountType,
  cashDiscountRateAmountValue,
  cashDiscountRateAmountType,
}: TourSelectionCardProps) => {
  const { isDesktop } = useDevice();

  return isDesktop ? (
    <DesktopTourSelectionCard
      cashDiscountType={cashDiscountType}
      cashDiscountRateAmountValue={cashDiscountRateAmountValue}
      cashDiscountRateAmountType={cashDiscountRateAmountType}
      full={full}
      personQuota={personQuota}
      packageId={packageId}
      packageDetailId={packageDetailId}
      companyCommissionAmount={companyCommissionAmount}
      price1={price1}
      price2={price2}
      price3={price3}
      price1Discounted={price1Discounted}
      price2Discounted={price2Discounted}
      price3Discounted={price3Discounted}
      childPriceList={childPriceList}
      pagesName={pagesName}
      departureDate={departureDate}
      departureText={departureText}
      arrivalDate={arrivalDate}
      arrivalText={arrivalText}
      departurePointList={departurePointList}
      dates={dates}
      roomQuota={roomQuota}
      hideQuotaInfo={hideQuotaInfo}
      days={days}
      status={status}
      entityName={entityName}
      checkInDate={checkInDate}
      checkOutDate={checkOutDate}
      tourType={tourType}
      currencyName={currencyName}
      tourId={tourId}
      data={data}
    />
  ) : (
    <MobileTourSelectionCard
      cashDiscountType={cashDiscountType}
      cashDiscountRateAmountValue={cashDiscountRateAmountValue}
      cashDiscountRateAmountType={cashDiscountRateAmountType}
      full={full}
      personQuota={personQuota}
      packageId={packageId}
      packageDetailId={packageDetailId}
      companyCommissionAmount={companyCommissionAmount}
      price1={price1}
      price2={price2}
      price3={price3}
      price1Discounted={price1Discounted}
      price2Discounted={price2Discounted}
      price3Discounted={price3Discounted}
      childPriceList={childPriceList}
      pagesName={pagesName}
      departureDate={departureDate}
      departureText={departureText}
      arrivalDate={arrivalDate}
      arrivalText={arrivalText}
      departurePointList={departurePointList}
      dates={dates}
      roomQuota={roomQuota}
      hideQuotaInfo={hideQuotaInfo}
      days={days}
      status={status}
      entityName={entityName}
      checkInDate={checkInDate}
      checkOutDate={checkOutDate}
      tourType={tourType}
      currencyName={currencyName}
      tourId={tourId}
      data={data}
    />
  );
};

export default TourSelectionCard;
